export default {
  meta: {
    title: '客户管理',
    parentPath: 'BOT配置',
    breadcrumbs: ['BOT配置', '客户管理'],
  },
};
